import { useEffect, useState } from 'react';
import { GetURLQuery } from 'utils/GetURLQuery';
import { Post } from 'Xhr/Xhr';
import SubmitNormalLoginData from '../Functions/SubmitNormalLoginData';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';

export const useLoginWithTakafol = (getValues,navigate) => {
  const cannotLogin = FindLangKey(
    'general-public-cant-login-system'
  );

  const [isSSO, setIsSSO] = useState(null);
  const [token, setToken] = useState();

  const code = GetURLQuery('code');
  const sso_token = localStorage.getItem('sso_token');

  useEffect(() => {
    if (isSSO) {
      Post(
        'POST',
        `${process.env.REACT_APP_API_URL_API_RETURN_GET_TOKEN}`,
        false,
        {}
      ).then((response) => {
        setToken(response.data.Data);
      });
    }
  }, [isSSO]);

  useEffect(() => {
    if (token) {
      const formValues = getValues();
      Post(
        'POST',
        `${process.env.REACT_APP_API_URL_API_RETURN_TAKAFOL}`,
        false,
        {
          nationalcode: formValues.username,
          token: token,
        }
      ).then((response) => {
        if (response.data.Data) {
          SubmitNormalLoginData(formValues, navigate);
        } else {
          SwalAlert('error', cannotLogin, false);
        }
      });
    }
  }, [token]);

  return { setIsSSO, code, sso_token };
};
